import { createContext } from "react";

const LeaderboardControlsContext = createContext<[boolean, React.Dispatch<React.SetStateAction<boolean>>] | undefined>(
  undefined
);
export default LeaderboardControlsContext;
